import type { RegionOption } from '../../../shared/regionAccessOptions';

/** The regions the edit modal lists: the ones the viewer may assign plus any the
 *  user already holds, which stay visible but locked. */
export function editableRegions(
  all: RegionOption[],
  heldIds: string[],
  assignableIds: string[],
): { regions: RegionOption[]; lockedRegionIds: string[] } {
  const regions = all.filter((r) => assignableIds.includes(r.id) || heldIds.includes(r.id));
  const lockedRegionIds = regions.filter((r) => !assignableIds.includes(r.id)).map((r) => r.id);
  return { regions, lockedRegionIds };
}
